module.exports = __webpack_public_path__ + "static/media/newsletter-april-2023-2.9cbcc7ce.jpg";